/*
Sep5-2023 Anushree:-
1. DateRangeFilterSection class handels date change in filter component 
2. calledBy- FilterSection.js
*/
import PropTypes from "prop-types";
import React from "react";
import ReactGA from "react-ga";
import moment from "moment-timezone";
import { FORM_FIELD_TYPE } from "../../../constants";
import styles from "../../../styles/FilterSection.module.scss";
import Form from "../../common/Form";

function DateRangeFilterSection(props) {
  const { tagType, selected, isSingleInput, onFilterChange, timezone } = props;
  const [selectedDate = {}] = selected;

  DateRangeFilterSection.propTypes = {
    tagType: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
      .isRequired,
    selected: PropTypes.array,
    isSingleInput: PropTypes.bool,
    onFilterChange: PropTypes.func.isRequired,
  };

  DateRangeFilterSection.defaultProps = {
    selected: [],
  };

  const onChange = (value, key) => {
    const [selectedDate] = selected;
    const dates = { ...selectedDate, [key]: value };

    if (dates.from && dates.to && dates.from > dates.to) {
      dates.to = dates.from;
    }

    let displayName = "";
    if (dates.from) displayName += moment(dates.from).format("DD MMM YYYY");
    if (dates.from && dates.to) displayName += ` - `;
    if (dates.to) displayName += moment(dates.to).format("DD MMM YYYY");
    const tag = { ...dates, id: tagType, type: tagType, displayName, timezone };
    onFilterChange(tag, dates.from || dates.to);
    if (dates.from || dates.to)
      ReactGA.event({ category: "filter", action: "date", label: tagType });
  };

  //Refractoring: Renaming startDate->FromDate, endDate->ToDate
  //const startDate = selectedDate?.from ? new Date(selectedDate?.from) : new Date();
  //const endDate = selectedDate?.to ? new Date(selectedDate?.to) : new Date(MAX_DATE);
  const fromDate = selectedDate?.from ? new Date(selectedDate?.from) : new Date();
  return (
    <Form
      config={
        isSingleInput
          ? [
              {
                id: "dateRange",
                type: FORM_FIELD_TYPE.DATE_RANGE_PICKER,
                size: {
                  lg: 12,
                  md: 12,
                  sm: 12,
                  xs: 12,
                },
                handleDateChange: (dateRange) => {
                  const [from, initialTo] = dateRange;
                  let to = initialTo;

                  if (from && to && from > to) {
                    to = from;
                  }

                  let displayName = "";
                  if (from) displayName += moment(from).format("DD MMM YYYY");
                  if (from && to) displayName += ` - `;
                  if (to) displayName += moment(to).format("DD MMM YYYY");
                  const tag = { id: tagType, type: tagType, displayName, from, to, timezone };
                  onFilterChange(tag);
                },
                dateRange: [
                  selectedDate?.from ? selectedDate?.from : null,
                  selectedDate?.to ? selectedDate?.to : null,
                ],
                //error: hasFormSaved && !targetGroup.validity,
              },
            ]
          : [
              {
                type: FORM_FIELD_TYPE.DATE,
                title: "From",
                onChange: (v) => onChange(v, "from"),
                value: selectedDate.from || null,
                placeholder: "DD MMM YYYY",
                defaultValue: fromDate,
              },
              {
                type: FORM_FIELD_TYPE.DATE,
                title: "To",
                onChange: (v) => onChange(v, "to"),
                value: selectedDate.to || null,
                disabled: !selectedDate.from,
                containerClassName: styles.toDate,
                placeholder: "DD MMM YYYY",
                minDate: fromDate,
                initialMonth: fromDate,
                defaultValue: fromDate,
              },
            ]
      }
    ></Form>
  );
}

export default DateRangeFilterSection;
